export const OPEN_COOKIE_SETTINGS = 'OPEN_COOKIE_SETTINGS'
export const CLOSE_COOKIE_SETTINGS = 'CLOSE_COOKIE_SETTINGS'

export const openCookieSettings = () => ({
    type: OPEN_COOKIE_SETTINGS,
})

export const closeCookieSettings = () => ({
    type: CLOSE_COOKIE_SETTINGS,
})
